import React, { Component } from 'react'
import ScenarioCard from '../components/ScenarioCard';
import scenario1 from '../assets/images/scenario-images/scenario1.webp'
import scenario2 from '../assets/images/scenario-images/scenario2.webp'
import scenario3 from '../assets/images/scenario-images/scenario3.webp'
import scenario4 from '../assets/images/scenario-images/scenario4.webp'
import scenario5 from '../assets/images/scenario-images/scenario5.webp'
import scenario6 from '../assets/images/scenario-images/scenario6.webp'
import scenario7 from '../assets/images/scenario-images/scenario7.webp'
import scenario8 from '../assets/images/scenario-images/scenario8.webp'
import scenario9 from '../assets/images/scenario-images/scenario9.webp'
import scenario10 from '../assets/images/scenario-images/scenario10.webp'
import scenario11 from '../assets/images/scenario-images/scenario11.webp'
import scenario12 from '../assets/images/scenario-images/scenario12.webp'
import scenario13 from '../assets/images/scenario-images/scenario13.webp'
import scenario14 from '../assets/images/scenario-images/scenario14.webp'
import scenario15 from '../assets/images/scenario-images/scenario15.webp'
import scenario16 from '../assets/images/scenario-images/scenario16.webp'
import scenario17 from '../assets/images/scenario-images/scenario17.webp'
import scenario18 from '../assets/images/scenario-images/scenario18.webp'
import {scenario_data} from '../data/json'

export default class ScenarioClass extends Component {

  state = {
    step: Math.floor(Math.random() * (19 - 1 + 1)) + 1
  }

  // proceed to the next step
  nextStep = () => {
    const { step } = this.state;
    if (step < 18) {
        this.setState({ step: step + 1 });
    } else {
        this.setState({ step: 1 });
    }
  }

   render() {
    const { step } = this.state
                       
    switch (step) {
      case 1: 
        return (
            <ScenarioCard 
                title={scenario_data.scenario_1.title} 
                number={scenario_data.scenario_1.number} 
                hashtags={scenario_data.scenario_1.hashtags} 
                body={scenario_data.scenario_1.bodytext} 
                questions={scenario_data.scenario_1.questions}
                imgSrc={scenario1}
                nextStep={ this.nextStep }
            />
        )
      case 2: 
        return (
            <ScenarioCard 
                title={scenario_data.scenario_2.title} 
                number={scenario_data.scenario_2.number} 
                hashtags={scenario_data.scenario_2.hashtags} 
                body={scenario_data.scenario_2.bodytext} 
                questions={scenario_data.scenario_2.questions}
                imgSrc={scenario2}
                nextStep={ this.nextStep }
            />
        )
      case 3: 
      return (
            <ScenarioCard 
                title={scenario_data.scenario_3.title} 
                number={scenario_data.scenario_3.number} 
                hashtags={scenario_data.scenario_3.hashtags} 
                body={scenario_data.scenario_3.bodytext} 
                questions={scenario_data.scenario_3.questions}
                imgSrc={scenario3}
                nextStep={ this.nextStep }
            />
      )
      case 4: 
      return (
            <ScenarioCard 
                title={scenario_data.scenario_4.title} 
                number={scenario_data.scenario_4.number} 
                hashtags={scenario_data.scenario_4.hashtags} 
                body={scenario_data.scenario_4.bodytext} 
                questions={scenario_data.scenario_4.questions}
                imgSrc={scenario4}
                nextStep={ this.nextStep }
            />
      )
      case 5: 
      return (
            <ScenarioCard 
                title={scenario_data.scenario_5.title} 
                number={scenario_data.scenario_5.number} 
                hashtags={scenario_data.scenario_5.hashtags} 
                body={scenario_data.scenario_5.bodytext} 
                questions={scenario_data.scenario_5.questions}
                imgSrc={scenario5}
                nextStep={ this.nextStep }
            />
      )
      case 6: 
      return (
            <ScenarioCard 
                title={scenario_data.scenario_6.title} 
                number={scenario_data.scenario_6.number} 
                hashtags={scenario_data.scenario_6.hashtags} 
                body={scenario_data.scenario_6.bodytext} 
                questions={scenario_data.scenario_6.questions}
                imgSrc={scenario6}
                nextStep={ this.nextStep }
            />
      )
      case 7: 
      return (
            <ScenarioCard 
                title={scenario_data.scenario_7.title} 
                number={scenario_data.scenario_7.number} 
                hashtags={scenario_data.scenario_7.hashtags} 
                body={scenario_data.scenario_7.bodytext} 
                questions={scenario_data.scenario_7.questions}
                imgSrc={scenario7}
                nextStep={ this.nextStep }
            />
      )
      case 8: 
      return (
            <ScenarioCard 
                title={scenario_data.scenario_8.title} 
                number={scenario_data.scenario_8.number} 
                hashtags={scenario_data.scenario_8.hashtags} 
                body={scenario_data.scenario_8.bodytext} 
                questions={scenario_data.scenario_8.questions}
                imgSrc={scenario8}
                nextStep={ this.nextStep }
            />
      )
      case 9: 
        return (
            <ScenarioCard 
                title={scenario_data.scenario_9.title} 
                number={scenario_data.scenario_9.number} 
                hashtags={scenario_data.scenario_9.hashtags} 
                body={scenario_data.scenario_9.bodytext} 
                questions={scenario_data.scenario_9.questions}
                imgSrc={scenario9}
                nextStep={ this.nextStep }
            />
        )
        case 10: 
        return (
            <ScenarioCard 
                title={scenario_data.scenario_10.title} 
                number={scenario_data.scenario_10.number} 
                hashtags={scenario_data.scenario_10.hashtags} 
                body={scenario_data.scenario_10.bodytext} 
                questions={scenario_data.scenario_10.questions}
                imgSrc={scenario10}
                nextStep={ this.nextStep }
            />
        )
        case 11: 
        return (
            <ScenarioCard 
                title={scenario_data.scenario_11.title} 
                number={scenario_data.scenario_11.number} 
                hashtags={scenario_data.scenario_11.hashtags} 
                body={scenario_data.scenario_11.bodytext} 
                questions={scenario_data.scenario_11.questions}
                imgSrc={scenario11}
                nextStep={ this.nextStep }
            />
        )
        case 12: 
        return (
            <ScenarioCard 
                title={scenario_data.scenario_12.title} 
                number={scenario_data.scenario_12.number} 
                hashtags={scenario_data.scenario_12.hashtags} 
                body={scenario_data.scenario_12.bodytext} 
                questions={scenario_data.scenario_12.questions}
                imgSrc={scenario12}
                nextStep={ this.nextStep }
            />
        )
        case 13: 
        return (
            <ScenarioCard 
                title={scenario_data.scenario_13.title} 
                number={scenario_data.scenario_13.number} 
                hashtags={scenario_data.scenario_13.hashtags} 
                body={scenario_data.scenario_13.bodytext} 
                questions={scenario_data.scenario_13.questions}
                imgSrc={scenario13}
                nextStep={ this.nextStep }
            />
        )
        case 14: 
        return (
            <ScenarioCard 
                title={scenario_data.scenario_14.title} 
                number={scenario_data.scenario_14.number} 
                hashtags={scenario_data.scenario_14.hashtags} 
                body={scenario_data.scenario_14.bodytext} 
                questions={scenario_data.scenario_14.questions}
                imgSrc={scenario14}
                nextStep={ this.nextStep }
            />
        )
        case 15: 
        return (
            <ScenarioCard 
                title={scenario_data.scenario_15.title} 
                number={scenario_data.scenario_15.number} 
                hashtags={scenario_data.scenario_15.hashtags} 
                body={scenario_data.scenario_15.bodytext} 
                questions={scenario_data.scenario_15.questions}
                imgSrc={scenario15}
                nextStep={ this.nextStep }
            />
        )
        case 16: 
        return (
            <ScenarioCard 
                title={scenario_data.scenario_16.title} 
                number={scenario_data.scenario_16.number} 
                hashtags={scenario_data.scenario_16.hashtags} 
                body={scenario_data.scenario_16.bodytext} 
                questions={scenario_data.scenario_16.questions}
                imgSrc={scenario16}
                nextStep={ this.nextStep }
            />
        )
        case 17: 
        return (
            <ScenarioCard 
                title={scenario_data.scenario_17.title} 
                number={scenario_data.scenario_17.number} 
                hashtags={scenario_data.scenario_17.hashtags} 
                body={scenario_data.scenario_17.bodytext} 
                questions={scenario_data.scenario_17.questions}
                imgSrc={scenario17}
                nextStep={ this.nextStep }
            />
        )
        case 18: 
        return (
            <ScenarioCard 
                title={scenario_data.scenario_18.title} 
                number={scenario_data.scenario_18.number} 
                hashtags={scenario_data.scenario_18.hashtags} 
                body={scenario_data.scenario_18.bodytext} 
                questions={scenario_data.scenario_18.questions}
                imgSrc={scenario18}
                nextStep={ this.nextStep }
            />
        )

      default: 
         // do nothing
    }

  }
}
